import React from 'react';
import { Col, Flex, Row, Skeleton as ASkeleton } from 'antd';

const Item = () => {
  return (
    <Flex vertical>
      <ASkeleton.Node active={true} style={{ width: '100%', marginBottom: 18, height: '260px' }} />
      <Flex justify={'space-between'} gap={6}>
        <ASkeleton.Button active={true} shape={'default'} block={true} />
        <ASkeleton.Button active={true} shape={'default'} block={true} />
      </Flex>
    </Flex>
  );
};

const Skeleton = () => {
  return (
    <Row gutter={[16, 24]} style={{ width: '100%' }}>
      {new Array(6).fill('').map((_, index) => (
        <Col span={8} key={index}>
          <Item />
        </Col>
      ))}
    </Row>
  );
};

export default Skeleton;
